import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Endpoints } from "src/app/core/resources/endpoints";
import { environment } from "../../../../environments/environment";
import { Utils } from "src/app/core/resources/utils";
import { Cargo } from "src/app/core/interfaces/cargo";
import { DiscountsAndBonuses } from "src/app/core/interfaces/discountsAndBonuses";
import { CargoPayment } from "src/app/core/interfaces/cargoPayment";
import { PDFTypes } from "src/app/core/enums/pdf-types.enum";
import { INCIDENT_ASSETS } from "src/app/core/resources/incident_assets";
import { AuthService } from "src/app/core/services/authentication.service";
import { CargoStateEnum } from "src/app/core/enums/cargoState.enum";
import { CargoTaxesPipe } from "src/app/core/pipe/cargo-taxes.pipe";
import { InspectionQuestion } from "src/app/core/interfaces/inspectionVehicle";
import { ApprovalStateEnum, TravelExpense, TravelExpenseDetail } from "src/app/core/interfaces/travel-expense";
import { PAYMENT_TYPES } from "src/app/core/enums/payment-types.enum";
import { CargoPaymentsService } from "src/app/core/services/cargo-payments.service";

@Injectable({
  providedIn: "root",
})
export class CargoItemService {
  reverseCompliment(cargoId: string, id: string, destinationId: string, addressId: string) {
    return this._http.post(`${environment.urlServerTeclogi}/cargo/consignment/cancel/initialFulfill`, { cargoId, consignment: [{ id, destinationId, addressId }] });
  }

  public integralValuesPercentageUrban = 3;
  public integralValuesPercentageGeneral = 3;

  constructor(
    private _http: HttpClient,
    private _endpointResources: Endpoints,
    public utils: Utils,
    public authService: AuthService,
    private cargoTaxesPipe: CargoTaxesPipe,
    private cargoPaymentsService: CargoPaymentsService
  ) { }

  getTotalDiscountsCostAdditionalServices(additionalServiceGroupCtrl) {
    if (
      additionalServiceGroupCtrl &&
      additionalServiceGroupCtrl.financialInformation &&
      additionalServiceGroupCtrl.financialInformation.modifications
    ) {
      const discounts =
        additionalServiceGroupCtrl.financialInformation.modifications.filter(
          (modification: DiscountsAndBonuses) => {
            return modification.type == 1;
          }
        );
      if (discounts.length) {
        const total = discounts.reduce((a, b) => {
          return { amount: a.amount + b.amount };
        });
        return total.amount;
      }
    }
    return 0;
  }

  public getTotalAdditionalRate(cargo: Cargo): number {
    if (cargo && cargo.additionalCosts && cargo.additionalCosts.length > 0) {
      return cargo.additionalCosts.reduce(
        (accum, item) =>
          item.financialInformation &&
            item.financialInformation.rate &&
            (item.type.id === "14" || item.type.id === "13")
            ? accum + item.financialInformation.rate
            : accum,
        0
      );
    }
    return 0;
  }

  public getTotalAdditionalCosts(cargo: Cargo): number {
    if (cargo && cargo.additionalCosts && cargo.additionalCosts.length > 0) {
      return cargo.additionalCosts
        .filter((additionalCost) => {
          return (
            additionalCost.type.productSiigoId == "14" ||
            (additionalCost.type.productSiigoId == "13" &&
              additionalCost.toPay &&
              additionalCost.toPay.code === "C")
          );
        })
        .reduce(
          (accum, item) =>
            item.financialInformation && item.financialInformation.cost
              ? accum + item.financialInformation.cost
              : accum,
          0
        );
    }
    return 0;
  }

  public getTotalAdditionalCostsDriver(cargo: Cargo): number {
    if (cargo && cargo.additionalCosts && cargo.additionalCosts.length > 0) {
      return cargo.additionalCosts.filter((additionalCost) => { return ((additionalCost.type.id === '14' && additionalCost.toPay && additionalCost.toPay.code === 'C') || (additionalCost.type.id === '13' && additionalCost.toPay && additionalCost.toPay.code === 'C')); }).reduce((accum, item) => item.financialInformation && item.financialInformation.cost ? accum + item.financialInformation.cost : accum, 0)
    }
    return 0;
  }


  public getTotalAdditionalRateDriver(cargo: Cargo): number {
    if (cargo && cargo.additionalCosts && cargo.additionalCosts.length > 0) {
      return cargo.additionalCosts.filter((additionalCost) => { return ((additionalCost.type.id === '14' && additionalCost.toPay && additionalCost.toPay.code === 'C') || (additionalCost.type.id === '13' && additionalCost.toPay && additionalCost.toPay.code === 'C')); }).reduce((accum, item) => item.financialInformation && item.financialInformation.rate ? accum + item.financialInformation.rate : accum, 0)
    }
    return 0;
  }

  getTotalBonusesCostAdditionalServices(additionalServiceGroupCtrl) {
    if (
      additionalServiceGroupCtrl &&
      additionalServiceGroupCtrl.financialInformation &&
      additionalServiceGroupCtrl.financialInformation.modifications
    ) {
      const discounts =
        additionalServiceGroupCtrl.financialInformation.modifications.filter(
          (modification: DiscountsAndBonuses) => {
            return modification.type == 0;
          }
        );
      if (discounts.length) {
        const total = discounts.reduce((a, b) => {
          return { amount: a.amount + b.amount };
        });
        return total.amount;
      }
    }
    return 0;
  }

  getTotalBonusesRate(cargo: Cargo): number {
    if (cargo && cargo.shippingCost && cargo.shippingCost.modifications) {
      const discounts = cargo.shippingCost.modifications.filter(
        (modification: DiscountsAndBonuses) => {
          return modification.type == 0;
        }
      );
      if (discounts.length) {
        const total = discounts.reduce((a, b) => {
          return { amountRate: a.amountRate + b.amountRate };
        });
        if (Number.isNaN(total.amountRate)) {
          return 0;
        }
        return total.amountRate;
      }
    }
    return 0;
  }

  getTotalBonusesRateAdditionalServices(additionalServiceGroupCtrl) {
    if (
      additionalServiceGroupCtrl &&
      additionalServiceGroupCtrl.financialInformation &&
      additionalServiceGroupCtrl.financialInformation.modifications
    ) {
      const discounts =
        additionalServiceGroupCtrl.financialInformation.modifications.filter(
          (modification: DiscountsAndBonuses) => {
            return modification.type == 0;
          }
        );
      if (discounts.length) {
        const total = discounts.reduce((a, b) => {
          return { amountRate: a.amountRate + b.amountRate };
        });
        if (Number.isNaN(total.amountRate)) {
          return 0;
        }
        return total.amountRate;
      }
    }
    return 0;
  }

  getTotalDiscountsRate(cargo: Cargo): number {
    if (cargo && cargo.shippingCost && cargo.shippingCost.modifications) {
      const discounts: DiscountsAndBonuses[] =
        cargo.shippingCost.modifications.filter(
          (modification: DiscountsAndBonuses) => {
            return modification.type == 1 && modification.amountRate > 0;
          }
        );
      if (discounts.length) {
        const total: DiscountsAndBonuses = discounts.reduce((a, b) => {
          return {
            amountRate: a.amountRate + b.amountRate,
          };
        });
        if (Number.isNaN(total.amountRate)) {
          return 0;
        }
        return total.amountRate;
      }
    }
    return 0;
  }

  getTotalDiscountsRateAdditionalServices(additionalServiceGroupCtrl) {
    if (
      additionalServiceGroupCtrl &&
      additionalServiceGroupCtrl.financialInformation &&
      additionalServiceGroupCtrl.financialInformation.modifications
    ) {
      const discounts: DiscountsAndBonuses[] =
        additionalServiceGroupCtrl.financialInformation.modifications.filter(
          (modification: DiscountsAndBonuses) => {
            return modification.type == 1 && modification.amountRate > 0;
          }
        );
      if (discounts.length) {
        const total: DiscountsAndBonuses = discounts.reduce((a, b) => {
          return {
            amountRate: a.amountRate + b.amountRate,
          };
        });
        if (Number.isNaN(total.amountRate)) {
          return 0;
        }
        return total.amountRate;
      }
    }
    return 0;
  }

  getNewValueRate(cargo: Cargo, amount, type?) {
    const value = amount || 0;
    if (type) {
      return cargo.shippingCost.rate - value;
    } else {
      return cargo.shippingCost.rate + value;
    }
  }

  getNewValueRateAdditionals(finantialInfo: any, amount, type?) {
    const value = amount || 0;
    if (type) {
      return finantialInfo.financialInformation.rate - value;
    } else {
      return finantialInfo.financialInformation.rate + value;
    }
  }

  getNewValueTotalCost(cargo: Cargo, amount, type): number {
    const value = amount || 0;
    let sum = type ? -value : value;
    return this.getRealCost(cargo, false) + sum;
  }

  getNewValueCostAdditionals(finantialInfo: any, amount, type) {
    const value = amount || 0;
    if (type) {
      return finantialInfo.financialInformation.cost - value;
    } else {
      return finantialInfo.financialInformation.cost + value;
    }
  }

  getRealTotalCost(cargo: Cargo) {
    if (
      cargo &&
      cargo.shippingCost &&
      this.utils.isDefined(cargo.shippingCost.totalCost)
    ) {
      let taxes = cargo.shippingCost.retefteValue + cargo.shippingCost.reteicaValue;
      const fopatValue = this.cargoTaxesPipe.transform(cargo.shippingCost.fopatValue, this.cargoPaymentsService.isChargeFopat(cargo));
      if (fopatValue) taxes += fopatValue;
      if (this.cargoPaymentsService.isTeclogiUser()) taxes += cargo.shippingCost.integralValue;
      return (
        cargo.shippingCost.totalCost -
        this.cargoPaymentsService.getTotalDiscounts(cargo) +
        this.cargoPaymentsService.getTotalBonuses(cargo) -
        taxes
      );
    } else {
      return 0;
    }
  }

  getRealCost(cargo: Cargo, includeAdditionalCosts: boolean = true) {
    if (
      cargo &&
      cargo.shippingCost &&
      this.utils.isDefined(cargo.shippingCost.totalCost)
    ) {
      return (
        cargo.shippingCost.totalCost -
        this.cargoPaymentsService.getTotalDiscounts(cargo) +
        this.cargoPaymentsService.getTotalBonuses(cargo) +
        (includeAdditionalCosts ? this.getTotalAdditionalCosts(cargo) : 0)
      );
    } else {
      return 0;
    }
  }

  getTotalValueAdvance(cargo: Cargo) {
    let value = 0;
    if (
      cargo && cargo.shippingCost &&
      this.utils.isDefined(cargo.shippingCost.valueAdvance) &&
      this.utils.isDefined(cargo.shippingCost.totalPaid)
    ) value = (cargo.shippingCost.payments && cargo.shippingCost.payments.length) ? this.sumItemArray(cargo.shippingCost.payments) : cargo.shippingCost.valueAdvance;
    return value;
  }

  /**
   * Valor de anticipo a mostrar. Conserva el cálculo actual si el anticipo ya
   * está pagado, el porcentaje es 0 o el saldo es 0. Si el anticipo supera el
   * saldo, muestra el saldo.
   */
  getPayableAdvance(cargo: Cargo, balance: number, currentAdvance?: number): number {
    const advance = this.utils.isDefined(currentAdvance) ? currentAdvance : this.getTotalValueAdvance(cargo);
    const shippingCost = cargo && cargo.shippingCost;
    if (!shippingCost || shippingCost.advanceState) return advance;
    if (shippingCost.advancePercentage === 0 || balance === 0) return advance;
    if (advance > balance) return balance;
    return advance;
  }

  async getSummaryBalance(cargo: Cargo, travelExpenses?: TravelExpense[]) {
    const modifications = this.utils.getNestedValue(cargo, 'shippingCost.modifications');
    const hasTravelExpensesModifications = modifications && modifications.length && modifications.some(modification =>
      modification && modification.typeModification && modification.typeModification.name &&
      ["Bono por legalización de viáticos", "Descuento por legalización de viáticos"].includes(modification.typeModification.name));
    let balance = 0;
    if (travelExpenses && travelExpenses.length && !hasTravelExpensesModifications)
      balance = await this.cargoPaymentsService.getBalance(cargo, true, travelExpenses);
    else
      balance = this.cargoPaymentsService.getTotalValueBalance(cargo);
    let modificationValue = 0;
    modificationValue += this.cargoPaymentsService.getTotalBonuses(cargo);
    modificationValue -= this.cargoPaymentsService.getTotalDiscounts(cargo);
    const payments = [];
    if (cargo.shippingCost.payments) {
      cargo.shippingCost.payments.forEach(object => {
        const { type, amount } = object;
        const accObject = payments.find(item => item.type === type);
        if (accObject) {
          accObject.amount += amount;
        } else {
          payments.push({ type, amount });
        }
      });
      payments.forEach(payment => {
        payment.label = this.getTypePaid(payment.type);
      })
    }
    let summaryBalance = {
      reteFuente: this.cargoTaxesPipe.transform(cargo.shippingCost.retefteValue, this.cargoPaymentsService.isChargeTaxes(cargo)),
      reteica: this.cargoTaxesPipe.transform(cargo.shippingCost.reteicaValue, this.cargoPaymentsService.isChargeTaxes(cargo)),
      fopat: this.cargoTaxesPipe.transform(cargo.shippingCost.fopatValue, this.cargoPaymentsService.isChargeFopat(cargo)),
      bonus: this.cargoPaymentsService.getTotalBonuses(cargo),
      discounts: this.cargoPaymentsService.getTotalDiscounts(cargo),
      totalCost: cargo.shippingCost.totalCost + modificationValue,
      initialCost: cargo.shippingCost.totalCost,
      payments: payments,
      balance: balance,
      balanceState: cargo.shippingCost.balanceState,
      travelExpenses
    };

    if (this.cargoPaymentsService.isTeclogiUser()) summaryBalance['integral'] = cargo.shippingCost.integralValue;
    return summaryBalance;
  }

  getCargoBalancePaid(cargo: Cargo): number {
    let value = 0;
    if (cargo && cargo.shippingCost && cargo.shippingCost.payments) {
      cargo.shippingCost.payments.forEach((payment) => {
        if (payment.type === "balance") {
          value += payment.amount;
        }
      });
    }
    return value;
  }

  getUtilityCargo(rate, totalCost) {
    if (!rate) return 0;
    const utilityValue = ((rate - totalCost) / rate) * 100;
    if (!Number.isNaN(utilityValue)) {
      return Math.round(utilityValue);
    }
    return 0;
  }

  // Igual que getUtilityCargo pero sin Math.round: para validar contra la utilidad mínima
  // (10,9% no debe pasar como 11%).
  getExactUtilityCargo(rate, totalCost): number {
    if (!rate) return 0;
    const utilityValue = (rate - totalCost) * 100 / rate;
    return !Number.isNaN(utilityValue) ? utilityValue : 0;
  }

  public getCargoInvoicePDF(cargoId: string) {
    let params = new HttpParams();
    params = params.append("cargoId", cargoId);
    return this._http.get(
      environment.urlServerTeclogi + this._endpointResources.getCargoInvoicePDF,
      {
        params,
        responseType: "blob",
      }
    );
  }

  public getCargoJournalPdf(cargoId: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('cargoId', cargoId);
    return this._http.get(
      environment.urlServerTeclogi + this._endpointResources.cargoJournalPdf,
      { params, responseType: 'blob' }
    );
  }

  public sumItemArray(shippingCost) {
    if (!shippingCost) return 0;
    const result = shippingCost
      .filter((item) => (item.type == "extraAdvance" || item.type === 'advance'))
      .map((item) => item.amount)
      .reduce((prev, curr) => prev + curr, 0);
    return result;
  }

  public isApproveBalance(cargo: Cargo): boolean {
    return (
      !this.utils.isEmpty(cargo) &&
      cargo &&
      cargo.shippingCost &&
      !this.utils.isEmpty(cargo.shippingCost.approveBalance) &&
      cargo.shippingCost.approveBalance === true &&
      cargo.shippingCost.balanceState === false
    );
  }

  public confirmDrive(data: any, approval: string): Observable<Cargo> {
    return this._http.post<Cargo>(
      environment.urlServerTeclogi +
      this._endpointResources.confirmDriver +
      "approval=" +
      approval,
      data
    );
  }

  public getInspection(id: string, type: "vehicle" | "container" = "vehicle") {
    if (type == "vehicle")
      return this._http.get(
        `${environment.urlServerTeclogi}${this._endpointResources.inspection}?inspectionId=${id}`
      );
    else if (type == "container")
      return this._http.get(
        `${environment.urlServerTeclogi}${this._endpointResources.inspection}/container?inspectionId=${id}`
      );
  }

  public sendInspection(
    data: any,
    type: "VEHICLE" | "CONTAINER" | "motorcycle",
    cargoId: string
  ): Observable<Cargo> {
    return this._http.post<Cargo>(
      `${environment.urlServerTeclogi}${this._endpointResources.inspection
      }?inspectionType=${type}&cargoId=${cargoId}`,
      data
    );
  }

  public approveInspection(
    data: any,
    approval: boolean,
    type: "vehicle" | "container" = "vehicle"
  ): Observable<any> {
    data.type = type;
    return this._http.post(
      `${environment.urlServerTeclogi}${this._endpointResources.inspection
      }/approval?approval=${approval ? "true" : "false"}`,
      data
    );
  }

  public getVehicleInsuranceDiscountCargo(cargo: Cargo) {
    const integralValuesPercentage = this.utils.getNestedValue(cargo, 'shippingCost.integralValuesPercentage');
    const totalCost = this.utils.getNestedValue(cargo, 'shippingCost.totalCost');
    const realTotalCost = totalCost === undefined ? 0 : totalCost;
    if (integralValuesPercentage)
      return (realTotalCost * integralValuesPercentage) / 100;
    if (this.utils.getNestedValue(cargo, 'cargoModel.tripType.name') === "Urbana")
      return (realTotalCost * this.integralValuesPercentageUrban) / 100;
    return (realTotalCost * this.integralValuesPercentageGeneral) / 100;
  }

  public approvePayBalance(
    cargoId: string,
    approve: boolean
  ): Observable<Cargo> {
    let params = new HttpParams();
    params = params.append("approve", approve.toString());
    return this._http.put<Cargo>(
      environment.urlServerTeclogi +
      this._endpointResources.approvePayBalance +
      "/" +
      cargoId,
      {},
      { params }
    );
  }

  public getInspectionPDF(
    cargoId: string,
    licensePlate: string,
    type: "vehicle" | "container" = "vehicle"
  ): Observable<Blob> {
    if (type == "vehicle") {
      let params = new HttpParams();
      params = params.append(
        "pdfType",
        PDFTypes.VEHICLE_INSPECTION
      );
      params = params.append("licensePlate", licensePlate);
      params = params.append("cargoId", cargoId);
      return this._http.get(
        environment.urlServerTeclogi +
        this._endpointResources.getVehicleInspectionPDF,
        {
          params,
          responseType: "blob",
        }
      );
    } else if (type == "container") {
      let params = new HttpParams();
      params = params.append(
        "pdfType",
        PDFTypes.CONTAINER_INSPECTION
      );
      params = params.append("licensePlate", licensePlate);
      params = params.append("cargoId", cargoId);
      return this._http.get(
        environment.urlServerTeclogi +
        this._endpointResources.getVehicleInspectionPDF,
        {
          params,
          responseType: "blob",
        }
      );
    }
  }

  public getInspectionQuestions(inspectionType: 'motorcycle' | 'cargoVehicle' | 'container', version: number): Observable<InspectionQuestion[]> {
    let params = new HttpParams();
    params = params.append("inspectionType", inspectionType);
    params = params.append("versions", `["${version}"]`);
    return this._http.get<InspectionQuestion[]>(`${environment.urlServerTeclogi}${this._endpointResources.getInspectionQuestions}`, { params });
  }

  public requestAdvance(id: string, request: boolean, paymentType: string) {
    let url = `${environment.urlServerTeclogi}${this._endpointResources.requestAdvance}?cargoId=${id}&request=${request}`;
    if (paymentType !== "" && paymentType !== 'Cualquiera') {
      url += `&paymentType=${paymentType}`;
    }
    let body = {
      id: `${id}`,
      request: `${request}`,
    };
    return this._http.put(url, body);
  }

  public getIndicator(cargo: Cargo) {
    if (cargo && cargo.state === CargoStateEnum.START_SERVICE) {
      if (cargo.stateTracking == "Start service" && !cargo.lastPointLocation)
        return INCIDENT_ASSETS[9];
      if (cargo.stateTracking == "Destination arrived" && !cargo.lastPointLocation)
        return INCIDENT_ASSETS[10];
      if (!!cargo.lastPointLocation) {
        const type = cargo.lastPointLocation.name;
        if (type == "Me detuve a dormir") return INCIDENT_ASSETS[0];
        if (type == "Me detuve a comer") return INCIDENT_ASSETS[1];
        if (type == "Cargando combustible") return INCIDENT_ASSETS[2];
        if (type == "Otro") return INCIDENT_ASSETS[6];
        if (type == "entregado") return INCIDENT_ASSETS[7];
        if (type == "Me pinché / varé") return INCIDENT_ASSETS[3];
        if (type == "Tuve un accidente") return INCIDENT_ASSETS[4];
        if (type == "La vía está cerrada") return INCIDENT_ASSETS[5];
      }
    }
    return INCIDENT_ASSETS[8];
  }

  getTypePaid(shippingCostType: PAYMENT_TYPES): string {
    const dictionary = {
      "advance": "Anticipo",
      "extraAdvance": "Extra anticipo",
      "balance": "Saldo",
      "additionalServicesLoad": "Servicio cargue",
      "additionalServicesDownload": "Servicio descargue",
      "additionalServicesLoadStandBy": "Stand by",
      "travelExpenses": "Viáticos",
    }
    if (dictionary[shippingCostType]) return dictionary[shippingCostType];
    return '-';
  }
}
